// src/services/authService.js
import { supabase } from '../services/supabaseClient';

const normalizeEmail = (email) => (email || '').trim().toLowerCase();

/** Login: devuelve { success, usuario } o { error } */
export async function login(email, password) {
  try {
    const e = normalizeEmail(email);
    if (!e || !password) {
      return { error: 'Falta correo o contraseña.' };
    }

    // 1) Auth
    const { data: authData, error: authError } =
      await supabase.auth.signInWithPassword({ email: e, password });

    if (authError || !authData?.user) {
      return { error: authError?.message || 'Correo o contraseña incorrectos.' };
    }

    const uid = authData.user.id;

    // 2) Perfil (UNA SOLA CONSULTA A usuarios)
    const { data: usuario, error: userErr } = await supabase
      .from('usuarios')
      .select('id,email,id_auth,empresa_id,rol,activo,nombre')
      .eq('id_auth', uid)
      .eq('activo', true)
      .maybeSingle(); // <- CLAVE

    if (userErr) {
      console.error('❌ Error consultando usuarios:', userErr);
      await supabase.auth.signOut();
      try { localStorage.removeItem('user'); } catch {}
      return { error: 'Error al validar el usuario.' };
    }

    if (!usuario) {
      await supabase.auth.signOut();
      try { localStorage.removeItem('user'); } catch {}
      return { error: 'Usuario no encontrado o inactivo en base de datos.' };
    }

    // 3) Nombre de empresa (opcional, como ya lo tenías)
    let empresa_nombre = '';
    if (usuario.empresa_id) {
      const { data: emp } = await supabase
        .from('empresas')
        .select('nombre')
        .eq('id', usuario.empresa_id)
        .maybeSingle();

      if (emp?.nombre) empresa_nombre = emp.nombre;
    }

    const usuarioFinal = {
      id: usuario.id,
      id_auth: usuario.id_auth,
      empresa_id: usuario.empresa_id,
      empresa_nombre,
      nombre: usuario.nombre,
      email: usuario.email,
      rol: usuario.rol,
    };

    try {
      localStorage.setItem('user', JSON.stringify(usuarioFinal));
    } catch {}

    return { success: true, usuario: usuarioFinal };
  } catch (err) {
    console.error('❌ LOGIN_FATAL', err);
    return { error: 'No se pudo iniciar sesión. Intenta de nuevo.' };
  }
}

/** Registro de usuario en Auth + inserción en `usuarios` (cuando haya uid) */
export async function registrarUsuario({ email, password, nombre, empresa_id, rol }) {
  try {
    const e = normalizeEmail(email);
    if (!e || !password) return { error: 'Falta correo o contraseña.' };

    const { data, error: authError } = await supabase.auth.signUp({
      email: e,
      password,
      options: { data: { nombre, rol, empresa_id } },
    });
    if (authError) return { error: authError.message };

    const uid = data?.user?.id || data?.session?.user?.id;
    if (!uid) {
      // Confirmación por correo activada ➜ completar después del primer login
      return { success: true, notice: 'Revisa tu correo para confirmar la cuenta.' };
    }

    const { error: dbError } = await supabase.from('usuarios').insert([
      { id_auth: uid, email: e, nombre, empresa_id, rol, activo: true },
    ]);
    if (dbError) return { error: dbError.message };

    return { success: true };
  } catch (err) {
    console.error('❌ SIGNUP_FATAL', err);
    return { error: 'No se pudo registrar el usuario.' };
  }
}

/** Logout */
export async function logout() {
  const { error } = await supabase.auth.signOut();
  if (error) return { error: error.message };
  try { localStorage.removeItem('user'); } catch {}
  return { success: true };
}